module.exports = __webpack_public_path__ + "img/havefun_title_kr.3d93323a.jpg";